import type { GetUserNotificationPreferencesQuery } from './graphql/GetUserNotificationPreferences.generated';

// ─────────────────────────────────────────────────────────────────────

export type NotificationCategory = Extract<
  GetUserNotificationPreferencesQuery['getUserNotificationPreferences'],
  { __typename: 'UserNotificationPreferences' }
>['notificationCategories'][number];

export type NotificationCategories = Omit<NotificationCategory, '__typename'>[];
